<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Plans</ion-title>
    <ion-button fill="clear" slot="end" (click)="addPlan()">
      <ion-icon name="add-outline"></ion-icon>
      Add
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div sxPadding="medium">
  <ion-list>
    <ion-item button="" *ngFor="let plan of plans" (click)="openViewPlanPage(plan)">
      <ion-label>{{plan.name}}</ion-label>
      <ion-label sxColor="two">{{plan.type}}</ion-label>
      <ion-label sxColor="two">{{plan.status}}</ion-label>
      <ion-icon slot="end" name="chevron-forward-outline"></ion-icon>
    </ion-item>
  </ion-list>
  </div>



</ion-content>
